 const UrlHelper = (model: Record<string, any>): string => {
    return Object.keys(model)
        .map((key) => {
            const value = model[key];
            // Include the key-value pair only if the value is not null or undefined
            return value !== null && value !== undefined ? `${key}=${encodeURIComponent(value)}` : `${key}=`;
        })
        .join('&');
};
export default UrlHelper
